module.exports = __webpack_public_path__ + "static/media/sf-test-13.38037e8f.mp3";